import { reRoomyPrivacyExtended } from './reRoomyExtended';

/** Full privacy page content per app slug. Missing slug → /{slug}/privacy-policy shows 404. */
export function getPrivacyPageContent(appSlug) {
  if (appSlug === 're-roomy') {
    return reRoomyPrivacyExtended;
  }
  return null;
}
